import DrawerBottom from './DrawerBottom.styled'

export default DrawerBottom
